<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/general-conditions-pt.png')" class="page__header" />
      <div class="page__container">
        <div class="d-flex justify-center mb-4">
          <p class="h1 h1--bold">Condições Gerais de Transporte de Encomendas Expresso e Carga</p>
        </div>
              <p class="body-2 justify-text">
                As Condições Gerais de Transporte regulam o transporte dos vários serviços Expresso. A informação aqui apresentada é de carater genérico e dá visibilidade às obrigações e direitos do prestador e do cliente de acordo com a legislação vigente que regula a atividade de transporte e entrega de mercadorias. Onde pode consultar as Condições Gerais de Transporte? As Condições gerais de transporte de Encomendas Expresso são publicadas e atualizadas em ctt.pt (https://www.ctt.pt/transversais/condicoes-gerais-transporte-encomendas-expresso) e estão também disponíveis para consulta em todas as Lojas e Pontos CTT. Sempre que sofrerem alterações ou atualizações será enviada uma carta a todos os clientes contratuais.
              </p>          
      </div>
      <div class="page__container">
        <div class="d-flex justify-center mb-4">
          <p class="h1 h1--bold">Condições Contratuais</p>
        </div>
              <p class="body-2 justify-text">
                As condições contratuais figuram na minuta do contrato a estabelecer com o cliente. Estas condições estão de acordo com a lei em vigor fazendo menção às Condições Gerais de Transporte, regulando os direitos e obrigações assumidos pelas Partes no ato da assinatura do contrato.
              </p>       
      </div>
      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">Vigência do Contrato</p>
        </div>
        <p class="body-2 justify-text">
          O contrato a celebrar produz efeitos a partir da data de assinatura e mantém-se em vigor por 12 meses, sem prejuízo das obrigações acessórias que devam perdurar para além da cessação do contrato.
        </p>
      </div>

      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">Faturação</p>
        </div>
        <p class="body-2 justify-text">
          Os serviços efetuados serão objeto de fatura mensal com resumo de todos os serviços realizados.
        </p>
      </div>

      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">Pagamento</p>
        </div>
        <p class="body-2 justify-text">
          As faturas devem ser liquidadas no prazo máximo de 30 (trinta) dias seguidos a contar da data de emissão das respetivas faturas e/ou documentos retificativos. 
          A reclamação de faturas e/ou documentos retificativos não é motivo para o não pagamento das faturas nos prazos estipulados.
        </p>
      </div>

      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">Validade da Proposta</p>
        </div>
        <p class="body-2 justify-text">
          Proposta com validade de 60 dias.
        </p>
      </div>

      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">Aprovação</p>
        </div>
        <p class="body-2 justify-text">
          Para efeitos de aceitação da proposta, esta deve ser rubricada em todas as páginas, à exceção da última que deve ser assinada e datada, e posteriormente devolvida ao gestor de cliente.
        </p>
      </div>

      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">Aplicação de IVA</p>
        </div>
        <p class="body-2 justify-text">
          Aos preços indicados acresce IVA à taxa legal em vigor.
        </p>
      </div>

      
      <Footer :page="previousPages + 1" />
    </div>
    <!-- Página contrato 2-->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/general-conditions-pt.png')" class="page__header" />
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Tempo de aviso de alteração de preços</p>
          </div>
          <p class="body-2 justify-text">
            A CTT Expresso terá de avisar o cliente por escrito com a antecedência mínima de 10 dias úteis antes da entrada em vigor dos novos preços.
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Reclamações</p>
          </div>
          <p class="body-2 justify-text">
            O Cliente deverá comunicar a perda, dano ou atraso na entrega do objeto, no prazo de 8 dias a contar da data de entrega do objeto ou da data na qual este deveria ter sido entregue. 
            No caso de atraso ou não liquidação do serviço adicional de cobrança, o Cliente deverá comunicar à CTT Expresso no prazo de 30 dias a contar da data em que a cobrança deveria ter sido recebida.
            Reclamação relativa a faturas e/ou documentos retificativos, o prazo máximo para a apresentação de reclamações pelo Cliente é de 60 dias seguidos a contar da data da respetiva emissão.
            A reclamação deverá ser apresentada através dos canais de apoio ao cliente contratual.
            Mais informações em ctt.pt (https://www.ctt.pt/transversais/condicoes-gerais-transporte-encomendas-expresso).
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Regulamento Geral de Proteção de Dados Pessoais de Clientes</p>
          </div>
          <p class="body-2 justify-text">
            Os CTT procuram respeitar as melhores práticas em matéria de segurança e proteção de dados pessoais. 
            Saiba aqui (https://www.ctt.pt/home/politica-privacidade/index) como são tratados os seus dados pessoais, 
            de acordo com o RGPD e restante legislação de proteção de dados pessoais.
          </p>
        </div>
        <div class="page__container mt-5">
        <div class="d-flex justify-center mb-4">
          <p class="h1 h1--bold">Condições Comerciais</p>
        </div>
        <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Utilização de opções de envio não contratadas</p>
          </div>
          <p class="body-2 justify-text">
            Aos serviços solicitados pelo cliente com opções não contratadas nas condições tarifárias, aplicam-se os preços base da oferta CTT Expresso.
          </p>          
        </div>
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Características dos objetos destinados a Lockers</p>
          </div>
          <p class="body-2 justify-text">
            Peso máximo por volume: 30kg; Medidas máximas por volume: 63cm x 43 cm x 54 cm.
          </p>
        </div>
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Taxas Disformes</p>
          </div>
          <p class="body-2 justify-text">
            Poderá aplicar-se taxa adicional aos envios que ultrapassem as dimensões e/ou peso standard das respetivas oferta Expresso.
          </p>
        </div>
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Taxa 9+</p>
          </div>
          <p class="body-2 justify-text">
            Esta regra aplica-se a envios com conceito múltiplo ou faturação agregada.Inclui a aplicação de um valor suplementar fixo por objeto, a partir do 10º de cada remessa/agregação e abrange envios compostos por 10 ou mais objetos com o mesmo produto, a mesma data, a mesma origem e destino.
          </p>
        </div>
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">Taxa de energia</p>
          </div>
          <p class="body-2 justify-text">
            Aos envios Expresso será aplicada uma taxa de combustível percentual com atualização mensal. Pode consultar a taxa atualizada em ctt.pt.
          </p>
        </div>
      <Footer :page="previousPages + 2" />
    </div>
    <!-- Página contrato 3-->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/general-conditions-pt.png')" class="page__header" />
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Taxa Recolha Não Efetuada
            </p>
          </div>
          <p class="body-2 justify-text">
            Aos envios Expresso aplica-se uma taxa por recolha não efetuada, 
            sempre que a recolha não é possível de realizar por questões imputáveis 
            ao local de recolha.
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Tempo de permanência no Pontos Pick&Drop Collectt
            </p>
          </div>
          <p class="body-2 justify-text">
            O prazo de permanência de uma encomenda Expresso num Ponto Pick&Drop Collectt 
            é de 5 dias úteis. Isto é válido quer se trate de um objeto com entrega direta 
            no Ponto quer se trate de um objeto que tenha ficado avisado.
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Regra do Peso Volumétrico
            </p>
          </div>
          <p class="body-2 justify-text">
            Será considerado o peso volumétrico para o cálculo do preço do envio, sempre que este seja superior ao peso real. Esta regra aplica- se a todos os envios Expresso. Mais informações em ctt.pt.
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Consumíveis
            </p>
          </div>
          <p class="body-2 justify-text">
            Os preços apresentados incluem a disponibilização de consumíveis de apoio 
            à expedição (etiquetas, saquetas plásticas, etc), para as quantidades de 
            tráfego médio mensal do cliente.
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Indemnização por incumprimento de serviços adicionais - DDA, Cobrança, Back
            </p>
          </div>
          <p class="body-2 justify-text">
            Reembolso do valor do serviço contratualizado (sem IVA). No caso de Cobrança 
            não efetuada ou incompleta, o valor de indemnização inclui também o valor da 
            cobrança ou da diferença no caso de cobrança efetuada com erro (troca de cheques, 
            valor de liquidação).
          </p>
        </div>

        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Indemnização por atraso de entrega ou devolução indevida do envio
            </p>
          </div>
          <p class="body-2 justify-text">
            Aplica-se às opções de envio: 10, 13/13M, 22, Para Amanhã (com janela horária de entrega), 
            Rede Shopping e Para Hoje. Em caso do não cumprimento do prazo de entrega ou horário de entrega, 
            por razões imputáveis à CTT Expresso, o cliente será indemnizado de acordo com as condições 
            apresentadas na tabela seguinte:
          </p>

          <div style="transform: scale(0.7); transform-origin: center;">
              <div >
                <table 
                  style="
                    width: 100%;
                    margin: 0 auto;
                    border-collapse: collapse;
                    font-size: 0.3rem;
                    border: none;
                  "
                >
                  <tr>
                    <td style="padding: 8px; border: 0.2px solid black;">Objeto entregue</td>
                    <td style="padding: 8px; border: 0.2px solid black;">Reembolso de 20% do porte de envio (sem IVA)</td>
                  </tr>
                  <tr>
                    <td style="padding: 8px; border: 0.2px solid black;">Objeto devolvido</td>
                    <td style="padding: 8px; border: 0.2px solid black;">Reembolso de 40% do porte de envio (sem IVA)</td>
                  </tr>
                </table>
              </div>
          </div>
        </div>

        <div class="page__container">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Serviço de Entrega com OTP (One Time Password)
            </p>
          </div>
          <p class="body-2 justify-text">
            Garante, através de um código PIN, a entrega ao destinatário final. O destinatário recebe 
            por email/SMS (caso tenha indicado) de modo a fornecer ao distribuidor no momento da entrega. 
            Caso o destinatário não receba o código PIN, ou caso não o tenha no momento da entrega, 
            é recolhida a assinatura do recetor.
          </p>
        </div>

      <Footer :page="previousPages + 3" />
    </div>
    <!-- Página contrato 4-->
    <div class="position-relative dinA4">
      <img :src="require('@/assets/general-conditions-pt.png')" class="page__header" />
      <div class="page__container mt-5">
        <div class="d-flex justify-left mb-4">
          <p class="h1 h1--bold" style="font-size:0.2rem">
            Indemnização por danos ou perda (Proteção base e extra e transporte de frágeis)
          </p>
        </div>
          <p class="body-2 justify-text">
            Restituição do valor pago pelos portes de envio (sem IVA)
          </p>
          <p class="body-2 justify-text">
            <strong>Proteção Base:</strong> no limite até ao valor da proteção base (10€/kg). Considerado o menor valor (sem IVA)
          </p>
          <p class="body-2 justify-text">
            <strong>Proteção Extra:</strong> no limite até ao valor da proteção extra contratada. Considerado o menor valor (sem IVA)
          </p>
          <p class="body-2 justify-text">
            <strong>Transporte de frágeis (apenas aplicável a danos):</strong> no limite até ao valor de 2.500€. Considerado o menor valor (sem IVA)
          </p>
          <p class="body-2 justify-text">
            <strong>Envios com proteção extra e transporte de frágeis:</strong> Em caso de dano, se a proteção extra contratada for inferior a 2.500€, o limite da indemnização é fixado pelo limite do transporte de frágeis de 2.500€. Caso a proteção extra contratada tenha cobertura superior a 2.500€, o limite da indemnização é fixado pelo valor da proteção extra contratado.
          </p>
          <p class="body-2 justify-text">
            <strong>Envios 13/19 Múltiplo:</strong> A proteção base, proteção extra e o transporte de frágeis, cobrem a totalidade da remessa e não envios individuais. No entanto, as indemnizações estarão limitadas aos danos específicos verificados e comprovados e não ao valor total da remessa.
          </p>
      </div>
        <div class="page__container mt-5">
          <div class="d-flex justify-left mb-4">
            <p class="h1 h1--bold" style="font-size:0.2rem">
              Comodato de Etiquetadora
            </p>
          </div>
          <p class="body-2 justify-text">
            No âmbito da prestação de serviços pela CTT Expresso ao Cliente e caso a expedição em causa reúna os pressupostos necessários 
            (mais de 250 envios/mês ou mais de 1.000€ faturação/mês), será cedido ao Cliente em regime de comodato, 
            uma máquina etiquetadora (doravante “máquina”), cuja manutenção e fornecimento de consumíveis ficarão a cargo da CTT Expresso.
          </p>
          <p class="body-2 justify-text">
            Finda a prestação de serviços ou caso deixem de se verificar os pressupostos subjacentes ao comodato da máquina, 
            o Cliente obriga-se a restituí-la em perfeitas condições e integralmente funcional.
          </p>
          <p class="body-2 justify-text">
            Caso o Cliente não restitua a máquina após notificação da CTT Expresso ou a restitua danificada, será o mesmo responsável pelo custo correspondente ao valor integral de aquisição de uma nova máquina conforme o valor de mercado vigente na data da devolução.
          </p>
        </div>

      <Footer :page="previousPages + 4" />
    </div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/general-conditions-pt.png')" class="page__header" />
      <div class="page__container body-2">
        Em prova de conformidade com o exposto, as partes assinam o presente contrato, para os efeitos oportunos, no local e data indicados.
        <table class="full-width mt-2">
          <tr>
            <td>
              <div class="d-flex justify-center">
                <p class="body-2 mb-0 mr-12">CTT Express</p>
              </div>
              <div class="pl-12">
                <div class="d-flex justify-center">
                  <img :src="require('@/assets/firma-pt.png')" class="mr-12 director-signature" />
                </div>

                <p class="body-1 mb-0 text-left">
                  {{ $t('PAGE2_DIRECTOR_NAME_PT') }}
                </p>
                <p class="body-2 mb-12 text-left">
                  {{ $t('PAGE2_DIRECTOR_JOB_PT') }}
                </p>
              </div>
            </td>
            <td class="pr-12">
              <div class="d-flex justify-center">
                <p class="body-2 mb-0 mr-12">O cliente</p>
              </div>
              <div class="d-flex justify-center">
                <p class="body-2 mb-0 mr-12">Assinatura, Carimbo e Data</p>
              </div>
              <div class="d-flex align-center pl-12 director-signature">
                <p class="body-2 mb-0">
                  <span class="white-font">SuFirma</span>
                </p>
              </div>

              <p class="body-2 mb-0 text-left">
                Nome e Apelidos:
                <span class="white-font euro-symbol">NombreYApellidos</span>
              </p>
              <p class="body-2 mb-12 text-left">
                Cargo da empresa, NIF:<span class="white-font">SuDNINIF</span>
              </p>
            </td>
          </tr>
        </table>
      </div>
      <Footer :page="previousPages + 7" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Footer'

export default {
  name: 'ContractText',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
      optyServicePoints: [],
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    numberOfServicePoints() {
      const number = this.optyServicePoints.length

      return number
    },
    fullServPointsIntermediatePages() {
      const maxNumberOfServicesPerPage = 14
      const maxNumberOfServicesIn1stPage = 8
      return Math.floor(
        (this.numberOfServicePoints - maxNumberOfServicesIn1stPage) / maxNumberOfServicesPerPage,
      )
    },
    servPointsLeft() {
      const maxNumberOfServicesPerPage = 14
      const maxNumberOfServicesIn1stPage = 8

      return (
        (this.numberOfServicePoints - maxNumberOfServicesIn1stPage) % maxNumberOfServicesPerPage
      )
    },
    servicesAgreementPages() {
      const maxNumberOfServicesIn1stPage = 8
      const maxNumberOfServicesForLastPage = 4
      const maxNumberOfServicesFor2PagesTotal =
        maxNumberOfServicesIn1stPage + maxNumberOfServicesForLastPage

      let pages = 1
      if (
        this.numberOfServicePoints > 1 &&
        this.numberOfServicePoints <= maxNumberOfServicesFor2PagesTotal
      ) {
        pages = 2
      } else {
        pages =
          2 +
          this.fullServPointsIntermediatePages +
          (this.servPointsLeft > maxNumberOfServicesForLastPage ? 1 : 0)
      }
      return pages
    },
  },
  methods: {
    getServicePoints() {
      const unorderedServicePoints = this[GET_OFFER_ITEM]('optyServicePoints')
      const orderedByCompromisedShipmentsServicePoints = unorderedServicePoints.sort((a, b) =>
        a.compromisedShipments < b.compromisedShipments ? 1 : -1,
      )
      return orderedByCompromisedShipmentsServicePoints
    },
    getLegalCity() {
      const legalCity = this[GET_OFFER_ITEM]('legalCity');

      if (legalCity && legalCity != "")
        return legalCity;

      return "Madrid / Barcelona / Sevilla / San Sebastián"
    }
  },
  created() {
    this.optyServicePoints = this.getServicePoints()
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('ContractText')
  },
}
</script>
